import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  label: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.bold
  },
  list: {
    padding: 0,
    boxShadow: 'none',
    border: 'none',
    borderRadius: '0'
  },
  listItem: {
    padding: 0
  },
  listContainer: {
    border: `1px solid ${capitalDesignTokens.foundations.colors.gray400}`,
    borderRadius: '4px'
  },
  parentListItemText: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyDefault
  },
  subfoldersList: {
    height: '152px',
    overflowY: 'auto',
    padding: 0,
    border: 'none',
    boxShadow: 'none',
    borderRadius: 0
  },
  subfolderListItemText: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyDefault
  },
  createNewFolderContainer: {
    padding: '8px'
  },
  depthLimitWarning: {
    color: capitalDesignTokens.foundations.colors.terracotta500,
    display: 'flex',
    gap: '4px',
    alignItems: 'center'
  },
  depthLimitWarningIcon: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyDefault
  }
});
